import { initializeVdpPromotionTracking } from '@Core/analytics';

/**
 * Product Details Page Analytics
 *
 * This module handles promotion analytics tracking for vehicle detail pages (VDP).
 * It automatically tracks when users visit a VDP after clicking a promotion,
 * enabling attribution tracking for promotion effectiveness.
 */

document.addEventListener('DOMContentLoaded', () => {
  // Initialize VDP promotion tracking with automatic vehicle data extraction
  initializeVdpPromotionTracking()
    .then(() => {
      console.debug('VDP promotion tracking initialized successfully');

      // Optional: You can access the tracker instance for manual tracking
      // tracker.trackVdpVisit({ stock_id: '12345', make: 'Ford', model: 'F-150', year: '2024' });
    })
    .catch((error) => {
      console.warn('Failed to initialize VDP promotion tracking:', error);
    });
});
